<template>
  <div class="list_container">
    <div class="item card" v-for="(item, index) in list" :key="item.id"
         :class="{'grid_item': isRadio}">
      <el-checkbox v-if="isRadio" v-model="item.radio" @change="onCheckboxChange(item)"
                   :class="{'isSelectCheck':item.radio }"></el-checkbox>
      <div class="item_info_container">
        <div class="title" :class="{'title_isRead': read(item.id)}">
          <span class="item_index" v-if="isShowIndex">
            {{index+1}}.
          </span>
          <img class="pdf_icon" v-if="item.qiniuUrl" src="@/assets/img/list_pdf_icon.png" alt="">
          <a v-if="$store.getters.userId" class="document_title" style="text-decoration:none;"
             :href="`https://www.infox-med.com/#/articleDetails?id=${item.id}`"
             @click="titleClick($event,item)">
            <span  class="document_title title_text" v-html="setTitle(item)"></span>
          </a>

          <span class="document_title hand title_text" @click="$login" v-else v-html="setTitle(item)"></span>
          <i v-if="!item.titleCn" class="iconfont icon-wenxianfanyi title_translate_icon hand"
             @click.stop="translate(item)"></i>
        </div>

         <div  class="document_title_en hand document_title title_text"  @click="titleClick($event,item)" v-if="(item.highLightTitleEn || item.titleEn) && (item.highLightTitleCn || item.titleCn)" v-html="item.highLightTitleCn || item.titleCn"></div>

        <div class="info_container">
          <p class="type info_item" v-if="item.categoryStr">
            <span>{{item.categoryStr}}</span>
            <span :class="`cnCtatus_${item.cnCtatus}`" v-if="[0, 1].includes(item.cnCtatus)">{{ item.cnCtatus === 1 ? '国内指南' : '国际指南' }}</span>
          </p>
          <p class="framer info_item">制定者：{{item.framer}}</p>
          <p class="source info_item" v-if="item.provenance">出处：{{item.provenance}}</p>
          <div class="info_item column">
            <span>科室：{{item.ejks}}</span>
            <span>发表时间：{{$initTime(item.docPublishTime)}}</span>
          </div>
        </div>
        <div class="docAbstract" v-if="item.docAbstract || item.docAbstractZh">
          <div class="abstract_item" v-if="item.docAbstract">
            <div class="abstract" :class="{'row_1': !item.isUnfoldAbs}"
                 v-html="highlight(item.highLightDocAbstract || item.docAbstract, 2)"></div>
            <img @click="item.isUnfoldAbs = !item.isUnfoldAbs"
                 src="https://img.infox-med.com/webImg/infoPc/icon/unfild_icon.png"
                 class="unfild_icon" :class="{'rotate_unfild': item.isUnfoldAbs}" alt="">
          </div>
          <div class="abstract_item" v-if="item.docAbstractZh">
            <div class="abstract" :class="{'row_1':!item.isUnfoldAbsZh}">
              {{item.docAbstractZh}}</div>
            <img class="unfild_icon" :class="{'rotate_unfild': item.isUnfoldAbsZh}"
                 src="https://img.infox-med.com/webImg/infoPc/icon/unfild_icon.png" alt=""
                 @click="item.isUnfoldAbsZh = !item.isUnfoldAbsZh">
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { getMyRead, setMyRead } from '@/utils/storage.js'
import { blankPagePar } from '@/utils/index.js'
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    isShowIndex: {
      type: Boolean,
      default: true
    },
    isRadio: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      readIds: []
    }
  },
  methods: {
    setTitle (item) {
      return item.highLightTitleEn || item.titleEn || item.highLightTitleCn || item.titleCn
    },
    onCheckboxChange (item) {
      this.$emit('checkboxChange', item)
    },
    translate (item) {
      if (!this.$store.getters.userId) return this.$login()
      item.isTranslate = !item.isTranslate
    },
    read (id) {
      return this.readIds.includes(id)
    },
    toDetails (item) {
      if (!this.$store.getters.userId) return this.$login()
      let arr = JSON.parse(getMyRead() || '[]')
      arr.unshift({
        id: item.id
      })
      arr = arr.map(items => {
        return JSON.stringify(items)
      })
      arr = [...new Set(arr)]
      arr = arr.map(it => {
        return JSON.parse(it)
      })
      setMyRead(arr)
      this.readIds.push(item.id)
      blankPagePar('guideDetails', {
        id: item.id
      })
    },
    titleClick (event, item) {
      const e = event || window.event
      e.preventDefault()
      // 个人中心-我的笔记逻辑
      if (item.noteCount) {
        e.preventDefault()
        this.$router.push({ path: '/noteDetails', query: { id: item.docId, guidelineId: item.id } })
        return
      }
      e.preventDefault()
      e.returnValue = false
      e.preventDefault ? e.preventDefault() : e.returnValue = false
      this.toDetails(item)
    },
    highlight (text, type) {
      const stylemap = {
        1: 'font-weight: 600; font-size: 18px;color: #c05600;',
        2: 'font-weight: 600; font-size: 14px;color: #000; '
      }
      return text ? text.replace(/<span/g, `<span style="${stylemap[type]}"`) : text
    }
  },
  created () {
    this.readIds = JSON.parse(getMyRead() || '[]').map(item => item.id)
  }
}
</script>

<style lang="less" scoped>
.list_container {
  display: grid;
  row-gap: 10px;
  .item {
    min-height: 30px;
    padding: 15px;
    transition: all 0.3s;
    &:hover {
      box-shadow: 6px 6px 7px 0 rgba(204, 204, 204, 0.5);
    }
  }
  .grid_item {
    display: grid;
    grid-template-columns: 24px 1fr;
    align-items: start;
    justify-content: space-between;
  }
  // 复选框
  /deep/ .isSelectCheck {
    .el-checkbox__inner {
      animation: isSelectCheckAnimation 0.3s ease;
    }
  }
  @keyframes isSelectCheckAnimation {
    0% {
      transform: rotate(0deg);
    }
    25% {
      transform: rotate(10deg);
    }
    50% {
      transform: rotate(0deg);
    }
    75% {
      transform: rotate(-10deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }

  .title {
    color: #4b639f;
    .item_index {
      font-size: 18px;
      // margin-right: 5px;
    }
  }
  .document_title {
    font-size: 18px;
    line-height: 1.5em;
    color: #4b639f;

    &:hover {
      text-decoration: underline;
      text-underline-offset: 5px;
    }
  }
  .document_title_en{
margin-top: 5px;
  font-size: 14px;
  color: #333;

  }

  .title_text{
  /deep/ span {
    color: #c05600 !important;
    }
  }
  .pdf_icon {
    position: relative;
    top: -3px;
    width: 16px;
    margin: 0 5px;
  }
  .title_translate_icon {
    font-size: 20px;
    margin-right: 0;
    margin-left: 10px;
  }
  .title_isRead {
    color: #8132b5 !important;
    .document_title {
      color: #8132b5 !important;
    }
  }
  .info_container {
    margin-top: 8px;
    .info_item {
      font-size: 14px;
      color: #666;
      line-height: 1.5em;
    }
    .column {
      display: grid;
      grid-template-columns: auto auto;
      align-items: center;
      justify-content: space-between;
    }
    .type{
      span{
        padding: 3px 6px;
        background: #eee;
        display: inline-block;
        border-radius: 2px;
        margin-bottom: 8px;
        &:not(:first-child){
          margin-left: 8px;
        }
      }
      .cnCtatus_0{
        color: #13A884;
        background: #E9F6F3;
      }
      .cnCtatus_1{
        color: #3B5FBA;
        background: #E1EAFA;
      }
    }
  }
  .docAbstract {
    // margin-top: 3px;
    // color: #666;
    // line-height: 1.3em;
    border-radius: 6px;
    padding: 8px 14px;
    background-color: #f5f7fb;
    margin-top: 12px;
    .abstract_item {
      display: grid;
      grid-template-columns: 1fr 20px;
      column-gap: 5px;
      padding-bottom: 6px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #e6e6e6;
      &:last-child {
        border-bottom: 0;
        padding-bottom: 0;
        margin-top: 11px;
      }
      &:first-child {
        margin-top: 0px;
      }
    }
    .unfild_icon {
      width: 100%;
      cursor: pointer;
      transform: rotate(0deg);
      transition: all 0.3s;
    }
    .rotate_unfild {
      transform: rotate(180deg);
    }
  }
  // .abstract_zh {
  //   background-color: #f5f7fb;
  //   padding: 10px;
  //   border-radius: 4px;
  //   line-height: 1.5em;
  // }
}
</style>
